"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readCookie = exports.createCookie = void 0;

var createCookie = function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=".concat(date.toGMTString());
  } else {
    expires = '';
  }

  document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=/");
};

exports.createCookie = createCookie;

var readCookie = function readCookie(name) {
  var nameEQ = "".concat(name, "=");
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) == 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }

  return null;
};

exports.readCookie = readCookie;